import DeveloperSettingsModal from '@/components/global/developer-settings';
import Button from '@/components/ui/button/index.tsx';
import React from 'react';
import { connect } from 'react-redux';

export const ErrorFallBack = ({ omitDevSettings = false }: { omitDevSettings?: boolean }) => {
  const handleRetry = () => {
    window.location.reload();
  };
  return (
    <div className='flex h-screen flex-col items-center justify-center relative'>
      {!omitDevSettings && (
        <div className="absolute top-8 right-8">
          <DeveloperSettingsModal />
        </div>
      )}
      <div className="flex h-[250px] w-[250px] items-center justify-center">
        <img src="../../../assets/error.svg" alt="Something went wrong" className="object-contain"/>
      </div>
      <h2 className='mb-[14px] mt-[21px] text-[28px] font-semibold'>Oops! Something went wrong.</h2>
      <p className='mb-[14px] text-center text-[16px]'>Please refresh the page or try again later.</p>
      <Button onClick={handleRetry} className='mt-[14px]'>
        Retry
      </Button>
    </div>
  );
};

interface ErrorBoundaryProps {
  bootApiError: boolean;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError || this.props.bootApiError) {
      return <ErrorFallBack />;
    }

    return this.props.children;
  }
}
const mapStateToProps = (state: {
  app: any; auth: { bootApiError: boolean }
} ) => ({
  bootApiError: state.app.bootApiError
});

export default connect(mapStateToProps)(ErrorBoundary);
